/* Import TinyMCE */
import hugerte from "hugerte";

/* Default icons are required. After that, import custom icons if applicable */
import "hugerte/icons/default";

/* Required TinyMCE components */
import "hugerte/themes/silver";
import "hugerte/models/dom";

/* Import a skin (can be a custom skin instead of the default) */
//import "hugerte/skins/ui/oxide/skin.css";

/* Import plugins */
//import "hugerte/plugins/advlist";
//import "hugerte/plugins/code";
//import "hugerte/plugins/emoticons";
//import "hugerte/plugins/emoticons/js/emojis";
import "hugerte/plugins/link";
//import "hugerte/plugins/lists";
//import "hugerte/plugins/table";

/* content UI CSS is required */
//import contentUiSkinCss from "hugerte/skins/ui/oxide/content.css";

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
//import contentCss from "hugerte/skins/content/default/content.css";

/* Initialize TinyMCE */
export function tinymceInit(config = {}) {
  // timeout because turbo isn't reliable on wanting to re-init things again
  setTimeout(() => {
    hugerte.init(
      Object.assign(
        {},
        {
          selector: ".tinymce",
          language: "et",
          language_url: "/tinymce-selfhost/et.js",
          promotion: false,
          height: 280,
          menubar: "",
          toolbar:
            "blocks fontsize | forecolor backcolor | bold italic underline strikethrough | removeformat",
          plugins: "link",
          color_cols: 5,
          skin_url: "/tinymce-selfhost/oxide",
          content_css: "/tinymce-selfhost/default/content.min.css",
          convert_unsafe_embeds: true
          //content_style: contentUiSkinCss.toString() + "\n" + contentCss.toString() Not possible with shakapacker. It cannot get those CSS as string
        },
        config
      )
    );
  }, 50);
}
